import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as AuthActions from '../actions/Auth';
import * as MoffAPIActions from '../actions/MoffApi';
import * as HeaderActions from '../actions/Header';
import DocterList from '../components/DoctorList';

const mapStateToProps = (state: any) => {
  return {
    // configureStore
    auth: state.auth,
    moffAPI: state.moffAPI,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    authActions: bindActionCreators(AuthActions, dispatch),
    moffAPIActions: bindActionCreators(MoffAPIActions, dispatch),
    headerActions: bindActionCreators(HeaderActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DocterList as any);



// WEBPACK FOOTER //
// ./src/containers/DoctorList.tsx